import { render } from "./activityCard.vue?vue&type=template&id=6045a74c&scoped=true&ts=true"
import script from "./activityCard.vue?vue&type=script&lang=ts"
export * from "./activityCard.vue?vue&type=script&lang=ts"

import "./activityCard.vue?vue&type=style&index=0&id=6045a74c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6045a74c"]])

export default __exports__